import Store from "../../store";

export default function(to, from, next) {
    if (to.matched.some(record => record.meta.home)) {
        next({ path: "/account" });
    }
    next();
}
